import React from "react";
import type { FC } from "react";
import logo from "src/assets/svgs/bv-logo-black.svg";

export interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = (props) => {
  return <img alt="Logo" src={logo} width={100} {...props} />;
};

export default Logo;
